import * as z from "zod";

const connectedTeamSchema = z.object({
  _id: z.string(),
  name: z.string(),
  logoUrl: z.string().optional(),
});

export const getConnectedTeamsGroup = {
  name: "getConnectedTeamsGroup" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ teams: z.array(connectedTeamSchema) }),
};

export const linkConnectedTeams = {
  name: "linkConnectedTeams" as const,
  input: z.object({ teamId: z.string(), otherTeamId: z.string() }),
  output: z.object({ success: z.boolean() }),
};

export const unlinkConnectedTeam = {
  name: "unlinkConnectedTeam" as const,
  input: z.object({ teamId: z.string(), otherTeamId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
